import WorkOrderSearchContext from "contexts/WorkOrderSearchContext";
import { useContext } from "react";
import useGetWorkOrders from "./useGetWorkOrders";

export default function useRefetchWorkOrders() {
  const { state: existingFilter } = useContext(WorkOrderSearchContext);
  const { fetch: refetchWorkOrders } = useGetWorkOrders();

  return {
    refetch: (args) => {
      refetchWorkOrders({ ...existingFilter, ...args });
    },
  };
}
